import { action, Action } from 'easy-peasy';

interface CutoutInfoType {
    left: number;
    total: number;
}

export interface ICutoutModel {
    cutoutInfo: CutoutInfoType;
    setCutoutInfo: Action<ICutoutModel, CutoutInfoType>;
}

export const cutoutModel: ICutoutModel = {
    cutoutInfo: {
        left: 0,
        total: 0,
    },
    setCutoutInfo: action((state, cutoutInfo) => {
        const { left, total } = cutoutInfo;
        state.cutoutInfo = { left, total };
    }),
};
